<template>
    <div>
<!--        Whatsapp broadcast "<strong>{{ $_.get(activity, "payload.title") }} </strong>" was cancelled.-->
        <span v-html="$t('notification.whatsappBroadcastCancelled', {title: $_.get(activity, 'payload.title') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WhatsappBroadcastCancelled",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
